import * as React from 'react';
import { UIText2, UIText3 } from '@cian/ui-kit';
import * as styles from './SubwayInfo.css';

interface ISubwayInfoProps {
  title: string;
  color: React.ReactElement | null;
  timeToSubway: string | null;
}

export function SubwayInfo({ title, color, timeToSubway }: ISubwayInfoProps) {
  return (
    <div className={styles['info']}>
      <span className={styles['info__subway']}>
        <span className={styles['info__subway-color']}>{color}</span>
        <UIText2>{title}</UIText2>
      </span>
      <mark className={styles['info__time']}>
        <UIText3>{timeToSubway}</UIText3>
      </mark>
    </div>
  );
}
